import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import styles from './TermsPage.module.css'; // Pode usar o mesmo CSS de termos se quiser, para padronizar

export default function PrivacyPolicyPage() {
  return (
    <>
      <Header />
      <main className={styles.termsMain}>
        <div className={styles.container}>
          <h1>Política de Privacidade</h1>
          
          <h2>1. Quem Somos</h2>
          <p>
            A Traily é uma plataforma B2B dedicada à gestão e distribuição de conteúdos digitais como ingressos de cinema, games, cash e gift cards. Prezamos pela transparência, segurança e privacidade dos dados pessoais que tratamos.
          </p>

          <h2>2. Dados Coletados</h2>
          <ul>
            <li>Dados cadastrais da empresa contratante (ex.: razão social, CNPJ, endereço, contatos comerciais).</li>
            <li>Dados de usuários autorizados (ex.: nome, e-mail, telefone corporativo).</li>
            <li>Dados técnicos (ex.: logs de acesso, IP, informações sobre dispositivo e navegador).</li>
          </ul>

          <h2>3. Finalidades do Tratamento</h2>
          <ul>
            <li>Viabilizar a prestação dos nossos serviços.</li>
            <li>Realizar comunicação necessária sobre produtos, pedidos ou suporte.</li>
            <li>Cumprir obrigações legais e regulatórias.</li>
            <li>Garantir a segurança da plataforma.</li>
            <li>Melhorar nossos serviços e experiência do usuário.</li>
          </ul>
          <p>Não comercializamos dados pessoais com terceiros.</p>

          <h2>4. Compartilhamento de Dados</h2>
          <ul>
            <li>
              Parceiros de conteúdo (como redes de cinema, plataformas de games, etc.) somente quando necessário para viabilizar o uso de vouchers ou conteúdos adquiridos.
            </li>
            <li>
              Prestadores de serviço que nos auxiliam na operação da plataforma (ex.: servidores, sistemas de segurança), sempre sob cláusulas de confidencialidade.
            </li>
            <li>
              Autoridades governamentais ou regulatórias, se houver obrigação legal ou judicial.
            </li>
          </ul>

          <h2>5. Bases Legais</h2>
          <ul>
            <li>Execução de contrato – quando necessário para prestar nossos serviços.</li>
            <li>Obrigação legal – quando exigido pela legislação.</li>
            <li>Legítimo interesse – para garantir segurança, prevenir fraudes ou melhorar nossos serviços.</li>
            <li>Consentimento – quando aplicável.</li>
          </ul>

          <h2>6. Segurança dos Dados</h2>
          <p>
            Adotamos medidas técnicas e administrativas para proteger os dados pessoais contra acessos não autorizados, perda, alteração ou divulgação indevida.
          </p>

          <h2>7. Direitos dos Titulares</h2>
          <ul>
            <li>Confirmar se realizamos tratamento de seus dados.</li>
            <li>Acessar os dados que possuímos sobre você.</li>
            <li>Corrigir dados incompletos, inexatos ou desatualizados.</li>
            <li>Solicitar anonimização, bloqueio ou eliminação de dados desnecessários.</li>
            <li>Solicitar a portabilidade dos dados.</li>
            <li>Revogar consentimento, quando o tratamento ocorrer sob essa base legal.</li>
          </ul>
          <p>Para exercer esses direitos, entre em contato pelo e-mail <a href="mailto:contato@traily.digital">contato@traily.digital</a>.</p>

          <h2>8. Retenção dos Dados</h2>
          <p>
            Manteremos os dados pessoais pelo tempo necessário para cumprir as finalidades para as quais foram coletados ou conforme exigências legais.
          </p>

          <h2>9. Alterações nesta Política</h2>
          <p>
            Esta Política poderá ser atualizada periodicamente. A versão vigente estará sempre disponível no site da Traily. A continuidade do uso da plataforma após mudanças implica aceitação dos novos termos.
          </p>

          <h2>10. Contato</h2>
          <p>
            Em caso de dúvidas, solicitações ou para exercer seus direitos, envie um e-mail para <a href="mailto:contato@traily.digital">contato@traily.digital</a>.
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}
